import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { isEmpty } from "lodash"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import SportDetail from "./sportDetail"
import axios from "axios"

const SportsOverview = () => {
  document.title = "Sport Overview"

  const { id } = useParams()
  const [sportDetail, setSportDetail] = useState({})
  const [error, setError] = useState(null)
  const [user, setUser] = useState({})

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("authUser"))
        if (!token) {
          throw new Error("Token not found")
        }
        const response = await axios.post(
          process.env.REACT_APP_DATABASEURL + "/admins/verify",
          { token: token }
        )
        const profile = response.data
        setUser(profile)
      } catch (err) {
        console.error("Error fetching profile data", err)
      }
    }
    fetchProfile()
  }, [])

  const fetchSportDetail = async sportId => {
    try {
      const sportResponse = await axios.get(
        `${process.env.REACT_APP_DATABASEURL}/sports/find-one/${sportId}`
      )
      setSportDetail(sportResponse.data)
    } catch (error) {
      setError(error.message)
    }
  }

  useEffect(() => {
    if (id) {
      fetchSportDetail(id)
    }
  }, [id])

  if (error) {
    return <div>Error: {error}</div>
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Sports" breadcrumbItem="Sport Overview" />
          {!isEmpty(sportDetail) && (
            <Row className="align-items-center justify-content-center">
              <Col lg="8">
                <SportDetail
                  sport={sportDetail}
                  fetchSportDetail={fetchSportDetail}
                />
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SportsOverview
